$(document).ready(function(){

    $('.featured-product-sec').each(function () {
        var $section = $(this);
        var $mainGallery = $section.find('.product__media-list');
        var $thumbGallery = $section.find('.featured-prd-thumbs');

        if (!$mainGallery.length || !$thumbGallery.length) return;

        // Prevent double initialization
        if ($mainGallery.hasClass('slick-initialized')) {
            $mainGallery.slick('unslick');
        }

        if ($thumbGallery.hasClass('slick-initialized')) {
            $thumbGallery.slick('unslick');
        }

        $mainGallery.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            adaptiveHeight: true,
            prevArrow: '<div class="featured-gallery-prev"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 12L13 23" stroke="#6C6B6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
            nextArrow: '<div class="featured-gallery-next"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 12L1 23" stroke="#6C6B6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
            asNavFor: $thumbGallery
        });

        $thumbGallery.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: $mainGallery,
            dots: false,
            infinite: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 749,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });

        // Custom thumbnail -> main slide
        $thumbGallery.on('click', '.featured-prd-thumb-item', function () {
            var index = $(this).index();
            $mainGallery.slick('slickGoTo', index);
            $thumbGallery.find('.featured-prd-thumb-item').removeClass('active-f-thumb');
            $(this).addClass('active-f-thumb');
        });

        // Main slide -> thumbnail active state
        $mainGallery.on('afterChange', function (event, slick, currentSlide) {
            $thumbGallery.find('.featured-prd-thumb-item').removeClass('active-f-thumb').eq(currentSlide).addClass('active-f-thumb');
        });
    });

    // Accordion behavior
    $('.faq-m .faq-question').on('click', function () {
        var faqItem = $(this).closest('.faq-item');
        var answer = faqItem.find('.faq-answer');

        if (faqItem.hasClass('active')) {
            // Close current
            faqItem.removeClass('active');
            answer.slideUp();
        } else {
        // Close all
            $('.faq-m .faq-item').removeClass('active');
            $('.faq-m .faq-answer').slideUp();

            // Open selected
            faqItem.addClass('active');
            answer.slideDown();
        }
    });

    // product page gallery slider
    $(".main-gallery-slick-enabled").slick({    
        dots: false,
        arrows: true,
        prevArrow: '<div class="arrow_prev"><svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.79021 18.7853C9.85671 18.7175 9.90947 18.6368 9.94547 18.5481C9.98147 18.4593 10 18.3641 10 18.268C10 18.1719 9.98147 18.0767 9.94547 17.988C9.90947 17.8992 9.85671 17.8186 9.79021 17.7507L1.72512 9.49981L9.79021 1.24893C9.8566 1.18099 9.90927 1.10034 9.9452 1.01158C9.98113 0.922817 9.99963 0.827682 9.99963 0.731607C9.99963 0.63553 9.98113 0.540396 9.9452 0.451632C9.90927 0.362869 9.8566 0.282219 9.79021 0.214283C9.72381 0.146347 9.64499 0.0924568 9.55824 0.0556908C9.47149 0.0189228 9.37852 0 9.28462 0C9.19072 0 9.09775 0.0189228 9.011 0.0556908C8.92425 0.0924568 8.84543 0.146347 8.77903 0.214283L0.209794 8.98248C0.143292 9.05036 0.0905304 9.13099 0.0545311 9.21976C0.0185308 9.30853 0 9.4037 0 9.49981C0 9.59592 0.0185308 9.69108 0.0545311 9.77985C0.0905304 9.86863 0.143292 9.94926 0.209794 10.0171L8.77903 18.7853C8.84537 18.8534 8.92417 18.9074 9.01093 18.9442C9.09768 18.981 9.19069 19 9.28462 19C9.37855 19 9.47156 18.981 9.55831 18.9442C9.64507 18.9074 9.72387 18.8534 9.79021 18.7853Z" fill="#9F9F9F"/></svg></div>',
        nextArrow: '<div class="arrow_next"><svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.209794 18.7853C0.143292 18.7175 0.0905301 18.6368 0.0545301 18.5481C0.0185301 18.4593 0 18.3641 0 18.268C0 18.1719 0.0185301 18.0767 0.0545301 17.988C0.0905301 17.8992 0.143292 17.8186 0.209794 17.7507L8.27488 9.49981L0.209794 1.24893C0.1434 1.18099 0.0907329 1.10034 0.0548005 1.01158C0.0188681 0.922817 0.000373881 0.827682 0.000373881 0.731607C0.000373881 0.63553 0.0188681 0.540396 0.0548005 0.451632C0.0907329 0.362869 0.1434 0.282219 0.209794 0.214283C0.276189 0.146347 0.35501 0.0924568 0.441759 0.0556908C0.528507 0.0189228 0.621484 0 0.71538 0C0.809276 0 0.902252 0.0189228 0.989001 0.0556908C1.07575 0.0924568 1.15457 0.146347 1.22097 0.214283L9.79021 8.98248C9.85671 9.05036 9.90947 9.13099 9.94547 9.21976C9.98147 9.30853 10 9.4037 10 9.49981C10 9.59592 9.98147 9.69108 9.94547 9.77985C9.90947 9.86863 9.85671 9.94926 9.79021 10.0171L1.22097 18.7853C1.15463 18.8534 1.07583 18.9074 0.989072 18.9442C0.902316 18.981 0.809309 19 0.71538 19C0.62145 19 0.528444 18.981 0.441687 18.9442C0.35493 18.9074 0.276128 18.8534 0.209794 18.7853Z" fill="#9F9F9F"/></svg></div>',
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        asNavFor: '.main-thumbs-slick-enabled',
        slidesToScroll: 1,
        adaptiveHeight: true
    });

    $(".main-thumbs-slick-enabled").slick({
        dots: false,
        asNavFor: '.main-gallery-slick-enabled',
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        verticalSwiping: false,
        vertical: true,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    verticalSwiping: false,
                    vertical: false
                }
            }
        ]
    });

    setTimeout(function () {
        $('.main-thumbs-slick-enabled').slick('setPosition');
    }, 200);

    $(".main-gallery-slick-enabled").on('afterChange', function(event, slick, currentSlide){
        var indexslide = currentSlide+1;
        console.log("Current Slide Index:", indexslide);
        $("ul.thumbnail-list li button[aria-current]").removeAttr("aria-current");
        $('ul.thumbnail-list li[data-media-position="' + indexslide + '"] button').attr("aria-current", "true");
    });

    $("ul.thumbnail-list").on("click", "li button", function () {
        var index = $(this).closest("li").data("media-position");
        if (typeof index !== 'undefined') {
            var slideIndex = parseInt(index, 10) - 1;
            $(".main-gallery-slick-enabled").slick("slickGoTo", slideIndex);
        }
    });

    const trigger = document.querySelector('.size_chart_drawer');
    const drawer = document.querySelector('#SizeChartDrawer');
    const drawerInner = drawer?.querySelector('.size-chart-drawer__inner');
    const closeButton = drawer?.querySelector('.size-chart-drawer__close');

    function openSizeChart() {
      document.body.classList.add('size-chart-open');
    }

    function closeSizeChart() {
      document.body.classList.remove('size-chart-open');
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openSizeChart();
    });

    closeButton?.addEventListener('click', function () {
      closeSizeChart();
    });

    drawer.addEventListener('click', function (event) {
      if (!drawerInner.contains(event.target)) {
        closeSizeChart();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSizeChart();
      }
    });

});